// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://fdcqcibrdsuvmdwagulk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZkY3FjaWJyZHN1dm1kd2FndWxrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0NDg5MjMsImV4cCI6MjA3MzAyNDkyM30.xo5WFGXxjhTiw8Uapq2Yv9X2nNAkhuxI0wDgh_-9Kzs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});